export default {
    data() {
        return {
            chooseCount: 0,
            //选修按钮索引
            allChecked: false,
            // 所有商品的数组
            order: [],
            // 总价
            totalprices: 0,

        }
    },
    methods: {
        //获取购物车商品信息全部勾选状态为false
        getShoppingCartDataFalse: function () {

            this.$post('shopping_cart/search', { token: this.$store.state.id, offset: '0', length: 9999,shop_id:this.$store.state.store.id }).then(res => {
                this.order = res.data.result.data;
                for (let val of this.order) {
                    val.selected = false;
                }
            })
        },
        //获取购物车商品信息全部勾选状态为true
        getShoppingCartDataTrue: function () {
            this.$post('shopping_cart/search', { token: this.$store.state.id, offset: '0', length: 9999,shop_id:this.$store.state.store.id }).then(res => {
                // // console.log(res)
                this.order = res.data.result.data;
                // // console.log(this.order)
                for (let val of this.order) {
                    val.selected = true;
                }
            })
        },
        //获取购物车商品信息
        updataShoppingCartData: function () {
            this.chooseCount = 0;
            this.$post('shopping_cart/search', { token: this.$store.state.id, offset: '0', length: 9999,shop_id:this.$store.state.store.id }).then(res => {
                // // console.log(res)
                this.order = res.data.result.data;
                // // console.log(this.order)
                for (let val of this.order) {
                    if (val.selected == 1) {
                        val.selected = true;
                    } else {
                        val.selected = false;
                    }
                }
                // 已选门数和总价钱的累加
                for (let val of this.order) {
                    if (val.selected) {
                        ++this.chooseCount;
                        this.totalprices += Number.parseFloat(val.product_price);
                    }
                }
                // 把已经勾选的true和false导入到数组循环遍历判断是否把全选钩打上
                let arr = [];
                // // console.log(this.order[0].selected)
                // // console.log(this.order.length)
                for (let n = 0; n < this.order.length; n++) {
                    arr[n] = this.order[n].selected;
                }
                // // console.log(arr)
                if (arr.includes(false)) {
                    this.allChecked = false;
                } else {
                    this.allChecked = true;
                }
            })
        },
        // getShoppingCartData: function () {
        //     this.order=[];
        //     this.totalprices=0;
        //     this.$post('shopping_cart/search', { token: this.$store.state.id, offset: '0', length: 9999 }).then(res => {           
        //         return res.data.result.data;
        //     }).then(data => {
        //         this.$store.state.shopNum=data.length;
        //         let arr = [];
        //         let me = this;
        //         for (let val of data) {
        //             (function (val) {
        //                 me.$post('products/get', { id: val.product_id }).then(res => {
        //                     let obj = {
        //                         id: val.id,
        //                         product_id: val.product_id,
        //                         selected: val.selected,
        //                         name: res.data.result.name,
        //                         image: res.data.result.image,
        //                         price: res.data.result.price
        //                     };
        //                     //累加总价
        //                     if(val.selected){
        //                         me.totalprices+=Number.parseFloat(res.data.result.price);
        //                     }
        //                     arr.push(obj);
        //                     me.order = arr;
        //                 })
        //             })(val)
        //         }
        //     })
        // },
        //全选按钮
        allChoose: function () {
            this.totalprices = 0;
            this.chooseCount = 0;
            if (this.allChecked == true) {
                for (let val of this.order) {
                    this.$post('shopping_cart/edit', { token: this.$store.state.id, selected: 0, id: val.id }).then(res => {
                        // // console.log(res)
                    })
                    this.getShoppingCartDataFalse();
                }
                // 结算按钮改为灰色
                document.getElementById('closeAnAccount').style.background = "rgb(201, 201, 201)";

            } else {
                for (let val of this.order) {
                    this.$post('shopping_cart/edit', { token: this.$store.state.id, selected: 1, id: val.id }).then(res => {
                        // // console.log(res)
                    })
                    this.getShoppingCartDataTrue();
                }
                // 已选门数和总价钱的累加
                for (let val of this.order) {

                    this.totalprices += Number.parseFloat(val.product_price);
                    
                    ++this.chooseCount;
                }
                // this.totalprices = this.totalprices.toFixed(2);
                // 结算按钮改为橙色
                document.getElementById('closeAnAccount').style.background = "rgb(255,128,0)";
            }

            // if (this.allChecked) {
            //     document.getElementById('closeAnAccount').style.background="rgb(201, 201, 201)";
            //     for (let val of this.order) {
            //         val.selected = false;
            //         this.chooseCount = 0;
            //     }
            //     this.totalprices = 0;
            //     this.selectedOrder = ""
            // } else {
            //     this.totalprices = 0;
            //     document.getElementById('closeAnAccount').style.background="rgb(255,128,0)";
            //     for (let val of this.order) {
            //         val.selected = true;
            //         this.chooseCount = this.order.length;
            //         this.totalprices += Number.parseFloat(val.price);
            //     }
            // }
        },
        //多选框按钮
        choose: function (id, index) {
            this.totalprices = 0;
            this.chooseCount = 0;
            // // console.log(index)
            // // console.log(this.order[index].selected)
            if (this.order[index].selected == true) {
                this.$post('shopping_cart/edit', { token: this.$store.state.id, selected: 1, id: id }).then(res => {
                    // // console.log(res)
                })
            }
            else {
                this.$post('shopping_cart/edit', { token: this.$store.state.id, selected: 0, id: id }).then(res => {
                    // // console.log(res)
                })
            }
            // 把已经勾选的true和false导入到数组循环遍历判断是否把全选钩打上
            let arr = [];
            // // console.log(this.order[0].selected)
            // // console.log(this.order.length)
            for (let n = 0; n < this.order.length; n++) {
                arr[n] = this.order[n].selected;
            }
            // // console.log(arr)
            if (arr.includes(false)) {
                this.allChecked = false;
            } else {
                this.allChecked = true;
            }
            // 改变结算按钮的颜色
            if (arr.includes(true)) {
                // 橙色
                document.getElementById('closeAnAccount').style.background = "rgb(255,128,0)";
            } else {
                // 灰色
                document.getElementById('closeAnAccount').style.background = "rgb(201, 201, 201)";
            }
            // 已选门数和总价钱的累加
            for (let val of this.order) {
                if (val.selected) {
                    ++this.chooseCount;
                    // // console.log(`累加之前总价：${this.totalprices}  单品价格：${Number.parseFloat(val.product_price)}`)
                    this.totalprices += Number.parseFloat(val.product_price);
                    // // console.log(`累加之后总价：${this.totalprices}`)
                    // // console.log('================')
                }
            }
            // this.chooseCount = 0;
            // this.totalprices = 0;
            // let select='';
            // for (let val of this.order) {  
            //     if (val.selected) {
            //         this.allChecked = true;
            //     } else {       
            //         this.allChecked = false;
            //         break;
            //     }
            // }
            // for (let val of this.order) {
            //     if (val.selected) { 
            //         ++this.chooseCount;
            //         this.totalprices += Number.parseFloat(val.price);
            //     }
            //     if(val.id===id){
            //         if(val.selected===false){
            //             select=0;
            //         }else if(val.selected===true){
            //             select=1;
            //         }else{
            //             select=val.select;
            //         }
            //     }
            // }
            // if(this.chooseCount!==0){
            //     document.getElementById('closeAnAccount').style.background="rgb(255,128,0)";
            // }else{
            //     document.getElementById('closeAnAccount').style.background="rgb(201, 201, 201)";
            // }
        },
        //跳转商品详情
        commodityDetails: function (id) {
            this.$router.push({
                path: '/classdetails',
                query: {
                    id: id
                }
            });
        },
        //删除商品
        deleteCommodity: function (product_id) {
            this.totalprices = 0;
            this.$post('shopping_cart/delete', { token: this.$store.state.id, id: product_id }).then(res => {
                this.updataShoppingCartData();

            })
            this.$message({
                message: '已移出购物车',
                type: 'success'
            });

        },
        // 结算按钮事件
        closeAccount: function () {
            // 产品id数组
            let selectedOrder = [];
            let falseArr = [];
            let shopId = [];
            // 整合已勾选商品的product_id和id到数组
            for (let val of this.order) {
                if (val.selected) {
                    selectedOrder.push(val.product_id);
                    shopId.push(val.id);
                } else {
                    falseArr.push(false);
                }
            }
            // 如果无勾选让结算按钮无操作
            if (falseArr.length === this.order.length) {
                // let model = document.querySelector('.shoppingRemind');
                // UIkit.modal(model).show();
                return;
            }
            // 跳转到pay支付页面传参product_id、id
            this.$router.push({
                path: '/pay',
                query: {
                    commodityList: JSON.stringify(selectedOrder),
                    shopId: JSON.stringify(shopId)
                }
            })
        },
    },
    created: function () {
        // 首次获取全部商品，默认全部勾选为false
        this.getShoppingCartDataFalse();
    },
    mounted: function () {
        document.title = '购物车';
    },
}

